<script>
import axios from "axios"
import Quiz from "../../../models/Quiz";
import Question from "./Question.vue";
import QuizProgress from "./QuizProgress.vue";
import VideoContentItem from "./ContentTypes/VideoContentItem.vue";
import PreRenderedContent from "./ContentTypes/PreRenderedContent.vue";

export default {
    name: "quiz",
    components: {
        Question,
        QuizProgress,
        PreRenderedContent,
        VideoContentItem,
    },
    computed: {
        postQuizContent() {

            if (this.postQuizContentItems && Array.isArray(this.postQuizContentItems)) {
                let renderedContent = '';
                this.postQuizContentItems.forEach(content => {
                    if (content.rendered) {
                        renderedContent += content.rendered;
                    }
                });
                return renderedContent;
            }
            return '';
        },
        showAfterQuizContent() {
            return this.quizProgress.data.complete
        },
        showName() {
            return this.quizLoaded && this.title.length > 0
        }
    },
    data() {
        return {
            postQuizContentItems: [],
            quizLoaded: false,
            quiz: new Quiz({name: 'Quiz Loading'}),
            quizProgress: {
                data: {
                    currentQuestion: 1,
                    numberOfQuestions: 0,
                    numberOfAnswered: 0,
                    progress: 0,
                    complete: false,
                    completeMessage: ''
                }
            }
        }
    },
    methods: {
        loadPostQuizContent() {
            const self = this
            const contentDiv = document.getElementById('after-quiz-content');
            contentDiv.classList.remove('d-none');
            const postQuizContentUrl = this.$root.$el.getAttribute('data-post-quiz-content-url');
            axios.get(postQuizContentUrl)
                .then(response => {
                    self.postQuizContentItems = response.data.data;
                    self.postQuizContentItems = response.data.data.map(item => {
                        // at the moment videos are displayed using their own Vue component, which requires some additional data
                        // to be passed to it. This is done by creating a new object with the type and props set to the appropriate info
                        if (item.typeHandle === 'video') {
                            return {
                                type: 'video-content-item',
                                props: {
                                    title: item.title,
                                    videoThumbnailSrc: item.contentTypeData.videoThumbnailSrc,
                                    videoUrl: item.contentTypeData.url,
                                }
                            };
                        } else {
                            // All other content types become pre-rendered content
                            return {
                                type: 'pre-rendered-content',
                                props: {
                                    rendered: item.rendered,
                                    title: item.title,
                                    contentTypeData: item.contentTypeData,
                                }
                            };
                        }
                    });
                })
                .catch(error => {
                    console.error(error)
                })
        },
        questionAnswered(questionData) {
            this.quiz.questions.data.forEach(question => {
                if (question.id === questionData.questionID) {
                    question.meta.correct = questionData.correct
                    question.meta.continueToNextQuestion = questionData.continueToNextQuestion
                }
            })
            // we now do trigger this when the user clicks close on the modal
            // this.updateQuestionVisibilities()
            this.quizProgress = questionData.quizProgress
        },
        updateQuestionVisibilities() {
            let lastWasCorrect = false
            let atLeastOneCorrect = false
            this.quiz.questions.data.forEach(question => {
                if (lastWasCorrect) {
                    question.meta.display = true
                    lastWasCorrect = false
                }
                if (question.meta.correct || question.meta.continueToNextQuestion) {
                    lastWasCorrect = true
                    atLeastOneCorrect = true
                    question.meta.display = false
                }
            })
            if (!atLeastOneCorrect) {
                this.quiz.questions.data[0].meta.display = true
            }
        }
    },
    mounted() {
        const self = this
        axios.get(this.baseApiUrl + this.quizId)
            .then(response => {
                self.quiz = new Quiz(response.data.data)
                self.quizProgress = response.data.data.quizProgress
                self.updateQuestionVisibilities()
                self.quizLoaded = true
            })
            .catch(error => {
                console.error(error)
            })
    },
    props: {
        postQuizContentUrl: {
            type: String,
            required: false
        },
        quizId: {
            type: String,
            required: true
        },
        baseApiUrl: {
            type: String,
            default: '/api/v1/courses/quizzes/'
        },
        title: {
            type: String,
            default: ''
        }
    },
    watch: {
        'quizProgress.data.complete'(newValue, oldValue) {
            if (newValue === true && oldValue === false) {
                this.loadPostQuizContent()
            }
        }
    }
}
</script>

<template>
    <div class="quiz">
        <h3 v-if="showName">{{ title }}</h3>
        <span v-if="quizLoaded" class="question-progress-text fw-bold fs-5">Question {{ quizProgress.data.currentQuestion }} / {{ quizProgress.data.numberOfQuestions }}</span>
        <question
            v-if="question.meta.display"
            v-for="question in quiz.questions.data"
            :question="question"
            :key="question.id"
            @question-answered="questionAnswered"
            @answer-modal-closed="updateQuestionVisibilities"
        ></question>

        <quiz-progress v-if="quizLoaded" :progress="quizProgress"></quiz-progress>
        <div class="after-quiz-content mt-4" v-if="showAfterQuizContent">
            <component v-for="(item, index) in postQuizContentItems"
                       :key="index"
                       :is="item.type"
                       v-bind="item.props">
            </component>
        </div>
    </div>
</template>
